(function () {
  'use strict';

  angular.module('gallery.upload', ['ui.router', 'ngResource']);
})();
